( function( app ) {
  const COMPONENT = {
    init: function() {
      const mediaQuery = window.matchMedia( '(min-width: 1024px)' );

      $( '.team-member-bio' ).each( function() {
        const component = $( this );
        const media = component.find( '.team-member-bio__media' ).first();
        const content = component.find( '.team-member-bio__content' ).first();

        const updateStickyState = function() {
          const contentHeight = content.outerHeight();
          const shouldStick = mediaQuery.matches && contentHeight > window.innerHeight;
          media.toggleClass( 'sticky', shouldStick );
        };

        updateStickyState();
        $( window ).on( 'load resize', updateStickyState );

        if ( 'ResizeObserver' in window ) {
          const observer = new ResizeObserver( updateStickyState );
          observer.observe( media[0] );
          observer.observe( content[0] );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'team-member-bio', COMPONENT );
} )( app );
